import { create } from 'zustand'

/** Whether the keyboard-shortcut sheet is open. */
export const useHelp = create<{ help: boolean; setHelp: (help: boolean) => void }>((set) => ({
  help: false,
  setHelp: (help) => set({ help }),
}))
